import type { JourneyContractSegment, PROMOTION_TYPES } from '@/domainLogic/index.ts';

export enum FARE_TYPE_STANDARD {
  STD = 'STD',
}

export type FARE_TYPE = PROMOTION_TYPES | FARE_TYPE_STANDARD;

export const getAirlineId = (segments: JourneyContractSegment[] | undefined): string | null => {
  if (!segments || segments.length === 0) return null;

  const result = [];

  for (let i = 0; i < segments.length; i++) {
    const { companyCode } = segments[i].transport;
    result.push(companyCode);
  }

  return result.join('#');
};

export const getRouteId = (segments: JourneyContractSegment[] | undefined): string | null => {
  if (!segments || segments.length === 0) return null;

  const result = [];
  for (let i = 0; i < segments.length; i++) {
    const departureHubId = segments[i].departure.hub.id;
    const arrivalHubId = segments[i].arrival.hub.id;
    result.push(`${departureHubId}-${arrivalHubId}`);
  }

  return result.join('#');
};
